import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskListDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "task-list-delete" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.372,17.39l-4.993,4.993a3,3,0,0,1-2.121.879H3.75a3,3,0,0,1-3-3V3.762a3,3,0,0,1,3-3h16.5a3,3,0,0,1,3,3V15.269A3,3,0,0,1,22.372,17.39Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,23.221V18.762a3,3,0,0,1,3-3h4.459"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15,
			y1: 6.762,
			x2: 9,
			y2: 12.762
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9,
			y1: 6.762,
			x2: 15,
			y2: 12.762
		})
	]
});
export default SvgTaskListDelete;
